
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16 16","fill":"#282828","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_1152_1959)"}},[_c('path',{attrs:{"d":"M12.665 7.993a.667.667 0 00-.667.667v5.337a.668.668 0 01-.666.668H2a.667.667 0 01-.667-.668v-9.34c0-.367.299-.666.667-.666h5.332a.667.667 0 000-1.335H2c-1.103 0-2 .898-2 2.002v9.34c0 1.103.897 2 2 2h9.332c1.102 0 2-.897 2-2V8.66a.666.666 0 00-.667-.667zM15.225 2.956l.413-.42c.507-.508.47-1.364-.036-1.871l-.266-.266c-.507-.507-1.362-.543-1.869-.036l-.42.414 2.178 2.18z"}}),_c('path',{attrs:{"d":"M5.997 7.847l-.017.017-1.305 3.356c-.032.083.05.166.137.137l3.345-1.313L14.9 3.297l-2.181-2.184-6.724 6.73.003.004zm-.575 2.071l.661-1.69a.491.491 0 00.13.23.53.53 0 00.438.144l.097-.01-.01.096a.548.548 0 00.147.443.522.522 0 00.438.143l.097-.01-.01.097a.53.53 0 00.143.439.536.536 0 00.252.136l-1.7.666-.683-.684zM12.94 2.94l.097.097-5.114 5.119-.097-.097L12.94 2.94z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_1152_1959"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h16v16H0z"}})])])])
          )
        }
      }
    